@if(dataSignal(); as data) {
<main class="product-detail main-layout">
  <div class="width-image mb-image">
    <div class="grid-img-product m-image">
      <div class="item" [style]="{ position: 'relative', 'background-color': !data.image_a ? '#ffffff' : '#f6f6f6' }">
        @if (data.image_a) {
        <img
          [src]="replaceBucket.replaceBucket(data.image_a)"
          [alt]="
            data.name + ' ' + data.tire_width + '/' + data.tire_height + 'R' + data.tire_size + ' ' + data.load_index + data.speed_rating
          "
          [title]="
            data.name + ' ' + data.tire_width + '/' + data.tire_height + 'R' + data.tire_size + ' ' + data.load_index + data.speed_rating
          "
          (click)="onClickVideoLinkUrl(data.image_a)"
          (keydown)="onClickVideoLinkUrl(data.image_a)"
          tabindex="0"
          loading="lazy"
        />
        @if(data.badge) { @if(data.badge.includes('new')) {
        <img
          class="badgeItem"
          src="assets/icons/icon-new-badge.png"
          alt="ไอคอนสำหรับยางตัวใหม่"
          title="ไอคอนสำหรับยางตัวใหม่"
          loading="lazy"
        />
        } @else if (data.badge.includes('hot')) {
        <img
          class="badgeItem"
          src="assets/icons/icon-hot-badge.png"
          alt="ไอคอนสำหรับยางยอดนิยม"
          title="ไอคอนสำหรับยางยอดนิยม"
          loading="lazy"
        />
        } @if(data.badge.includes('ev')) {
        <img
          class="badgeItemEV"
          src="assets/icons/icon-ev-badge.png"
          alt="ไอคอนสำหรับยางไฟฟ้า"
          title="ไอคอนสำหรับยางไฟฟ้า"
          loading="lazy"
        />
        } } }
      </div>
      <div class="item item-subItem" [style]="{ 'background-color': !data.image_b ? '#ffffff00' : '#f6f6f6' }">
        @if (data.image_b) {
        <img
          [src]="replaceBucket.replaceBucket(data.image_b)"
          [alt]="
            data.name + ' ' + data.tire_width + '/' + data.tire_height + 'R' + data.tire_size + ' ' + data.load_index + data.speed_rating
          "
          [title]="
            data.name + ' ' + data.tire_width + '/' + data.tire_height + 'R' + data.tire_size + ' ' + data.load_index + data.speed_rating
          "
          (click)="onClickVideoLinkUrl(data.image_b)"
          (keydown)="onClickVideoLinkUrl(data.image_b)"
          tabindex="0"
          loading="lazy"
        />
        }
      </div>
      <div class="item item-subItem" [style]="{ 'background-color': !data.image_c ? '#ffffff00' : '#f6f6f6' }">
        @if (data.image_c) {
        <img
          [src]="replaceBucket.replaceBucket(data.image_c)"
          [alt]="
            data.name + ' ' + data.tire_width + '/' + data.tire_height + 'R' + data.tire_size + ' ' + data.load_index + data.speed_rating
          "
          [title]="
            data.name + ' ' + data.tire_width + '/' + data.tire_height + 'R' + data.tire_size + ' ' + data.load_index + data.speed_rating
          "
          (click)="onClickVideoLinkUrl(data.image_c)"
          (keydown)="onClickVideoLinkUrl(data.image_c)"
          tabindex="0"
          loading="lazy"
        />
        }
      </div>
      <div class="item item-subItem" [style]="{ 'background-color': !data.image_d ? '#ffffff00' : '#f6f6f6' }">
        @if (data.image_d) {
        <img
          [src]="replaceBucket.replaceBucket(data.image_d)"
          [alt]="
            data.name + ' ' + data.tire_width + '/' + data.tire_height + 'R' + data.tire_size + ' ' + data.load_index + data.speed_rating
          "
          [title]="
            data.name + ' ' + data.tire_width + '/' + data.tire_height + 'R' + data.tire_size + ' ' + data.load_index + data.speed_rating
          "
          (click)="onClickVideoLinkUrl(data.image_d)"
          (keydown)="onClickVideoLinkUrl(data.image_d)"
          tabindex="0"
          loading="lazy"
        />
        }
      </div>
    </div>
  </div>

  <div>
    <div class="flex-product-layout product-layout">
      <img
        class="logo-product"
        [src]="replaceBucket.replaceBucket(data.brand_image)"
        [alt]="data.brand_name"
        [title]="data.brand_name"
        loading="lazy"
      />
      <h2 class="font-size-34 font-weight-bold">{{ data.name }}</h2>
    </div>
    @if (tireCheck && tireCheck.key_name === "tire") {
    <div class="flex-product-layout flex-between product-layout product-title">
      <span class="font-size-20 font-weight-medium tire-size">
        {{ data.tire_width }}/{{ data.tire_height }}R{{ data.tire_size }} {{ data.load_index }}{{ data.speed_rating }}
      </span>
      <div class="flex-tire-size">
        <!-- //NOTE for desktop -->

        <!-- //NOTE - old -->
        <mat-form-field
          appearance="outline"
          class="example-full-width selector-product-tire themeAdjustButton1"
          (click)="onClickChangeTireSize('up')"
        >
          <mat-icon matPrefix class="semi-bold">keyboard_arrow_up</mat-icon>
          <input
            type="text"
            placeholder="เพิ่มขนาดยาง"
            matInput
            [formControl]="myControlTireUp"
            [matAutocomplete]="autoUp"
            style="font-size: var(--autocomplete-desktop-font-size, 1.75rem); padding-inline: 0"
          />
          <!-- //NOTE - old -->
          <!-- <mat-autocomplete
            #autoUp="matAutocomplete"
            [displayWith]="displayFnUp"
            (optionSelected)="optionSelectedEmit($event, 'up')"
            /> -->
          <mat-autocomplete
            #autoUp="matAutocomplete"
            [displayWith]="displayFnUp"
            (optionSelected)="optionSelectedEmit($event, 'up')"
            (opened)="onAutoUpOpened()"
            (closed)="onAutoUpClosed()"
          >
            @for (option of filteredOptionsUp | async; track option) {
            <mat-option [value]="option.up_size">{{ option.up_size }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="example-full-width selector-product-tire themeAdjustButton1"
          (click)="onClickChangeTireSize('down')"
        >
          <mat-icon matPrefix class="semi-bold">keyboard_arrow_down</mat-icon>
          <input
            type="text"
            placeholder="ลดขนาดยาง"
            matInput
            [formControl]="myControlTireDown"
            [matAutocomplete]="autoDown"
            style="font-size: var(--autocomplete-desktop-font-size, 1.75rem); padding-inline: 0"
          />
          <!-- <mat-autocomplete
            #autoDown="matAutocomplete"
            [displayWith]="displayFnDown"
            (optionSelected)="optionSelectedEmit($event, 'down')"
          /> -->
          <mat-autocomplete
            #autoDown="matAutocomplete"
            [displayWith]="displayFnDown"
            (optionSelected)="optionSelectedEmit($event, 'down')"
            (opened)="onAutoDownOpened()"
            (closed)="onAutoDownClosed()"
          >
            @for (option of filteredOptionsDown | async; track option) {
            <mat-option [value]="option.down_size">{{ option.down_size }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        <!-- //NOTE - for mobile -->
        <mat-form-field
          appearance="outline"
          class="example-full-width selector-product-tire themeAdjustButton2"
          (click)="onClickChangeTireSize('up')"
        >
          <mat-icon matPrefix>keyboard_arrow_up</mat-icon>
          <input
            type="text"
            placeholder="เพิ่มขนาด"
            matInput
            [formControl]="myControlTireUp"
            [matAutocomplete]="autoUp"
            style="font-size: 1.25rem; padding-inline: 0"
          />
          <!-- //NOTE - old -->
          <!-- <mat-autocomplete
            #autoUp="matAutocomplete"
            [displayWith]="displayFnUp"
            (optionSelected)="optionSelectedEmit($event, 'up')"
            /> -->
          <mat-autocomplete
            #autoUp="matAutocomplete"
            [displayWith]="displayFnUp"
            (optionSelected)="optionSelectedEmit($event, 'up')"
            (opened)="onAutoUpOpened()"
            (closed)="onAutoUpClosed()"
          >
            @for (option of filteredOptionsUp | async; track option) {
            <mat-option [value]="option.up_size">{{ option.up_size }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="example-full-width selector-product-tire themeAdjustButton2"
          (click)="onClickChangeTireSize('down')"
        >
          <mat-icon matPrefix>keyboard_arrow_down</mat-icon>
          <input
            type="text"
            placeholder="ลดขนาด"
            matInput
            [formControl]="myControlTireDown"
            [matAutocomplete]="autoDown"
            style="font-size: 1.25rem; padding-inline: 0"
          />
          <!-- //NOTE - old -->
          <!-- <mat-autocomplete
            #autoDown="matAutocomplete"
            [displayWith]="displayFnDown"
            (optionSelected)="optionSelectedEmit($event, 'down')"
          /> -->
          <mat-autocomplete
            #autoDown="matAutocomplete"
            [displayWith]="displayFnDown"
            (optionSelected)="optionSelectedEmit($event, 'down')"
            (opened)="onAutoDownOpened()"
            (closed)="onAutoDownClosed()"
          >
            @for (option of filteredOptionsDown | async; track option) {
            <mat-option [value]="option.down_size">{{ option.down_size }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
    }

    <p class="font-size-14 font-weight-regular text-product-description info-tire">
      {{ data.short_description }}
    </p>
    <div class="flex-product flex-align-items flex-between gap-1-5">
      <div class="flex-product-price">
        <span class="font-size-14 price font-weight-bold text-price-label">ราคา</span>
        <span class="font-size-28 price font-weight-bold">{{ data.price | number }} บาท</span>
      </div>
      <!-- @if (categorySignal() === '1') {
      <button class="themeCompareButton1" mat-flat-button (click)="addToComparison(data)">+ เปรียบเทียบ</button>
      <button class="themeCompareButton2" mat-flat-button (click)="addToComparison(data)">+ เปรียบเทียบ</button>
      } -->

      <!-- @if (categorySignal() === '1') {
      <button class="themeCompareProductButton1" mat-flat-button (click)="clickPopup()">
        <span class="xl-mr-l-1">เลือกขนาดยาง</span>
      </button>
      } -->
    </div>
  </div>
</main>

@if (tireCheck && tireCheck.key_name === "tire") {
<section class="background-gray {{ this.isMobileView ? 'product-rate-mobile' : 'product-rate' }}">
  <ul>
    @if(data.perf_a){
    <li>
      <ngx-gauge
        [type]="gaugeType"
        [value]="$any(data.perf_a)"
        [min]="0"
        [max]="10"
        [thick]="this.isMobileView ? 10 : 15"
        [size]="gaugeSize()"
        foregroundColor="#0753A8"
      >
        <!-- <ngx-gauge-value> -->
        <!-- {{ data.gripWetRoad | number : '1.1-1' }} -->
        <!-- </ngx-gauge-value> -->
      </ngx-gauge>
      <span>การยึดเกาะบนถนนแห้ง</span>
    </li>
    } @if(data.perf_b){
    <li>
      <ngx-gauge
        [type]="gaugeType"
        [value]="$any(data.perf_b)"
        [min]="0"
        [max]="10"
        [thick]="this.isMobileView ? 10 : 15"
        [size]="gaugeSize()"
        foregroundColor="#0753A8"
      >
        <!-- <ngx-gauge-value> -->
        <!-- {{ data.gripDryRoad | number : '1.1-1' }} -->
        <!-- </ngx-gauge-value> -->
      </ngx-gauge>
      <span>การยึดเกาะบนถนนเปียก</span>
    </li>
    } @if(data.perf_c){
    <li>
      <ngx-gauge
        [type]="gaugeType"
        [value]="$any(data.perf_c)"
        [min]="0"
        [max]="10"
        [thick]="this.isMobileView ? 10 : 15"
        [size]="gaugeSize()"
        foregroundColor="#0753A8"
      >
        <!-- <ngx-gauge-value> -->
        <!-- {{ data.balanceControl | number : '1.1-1' }} -->
        <!-- </ngx-gauge-value> -->
      </ngx-gauge>
      <span>อายุการใช้งาน</span>
    </li>
    }

    <!-- </ul> -->
    <!-- <ul> -->
    @if(data.perf_d){
    <li>
      <ngx-gauge
        [type]="gaugeType"
        [value]="$any(data.perf_d)"
        [min]="0"
        [max]="10"
        [thick]="this.isMobileView ? 10 : 15"
        [size]="gaugeSize()"
        foregroundColor="#0753A8"
      >
        <!-- <ngx-gauge-value> -->
        <!-- {{ data.comfortable | number : '1.1-1' }} -->
        <!-- </ngx-gauge-value> -->
      </ngx-gauge>
      <span>ความนุ่มนวล</span>
    </li>
    } @if(data.perf_e){
    <li>
      <ngx-gauge
        [type]="gaugeType"
        [value]="$any(data.perf_e)"
        [min]="0"
        [max]="10"
        [thick]="this.isMobileView ? 10 : 15"
        [size]="gaugeSize()"
        foregroundColor="#0753A8"
      >
        <!-- <ngx-gauge-value> -->
        <!-- {{ data.silence | number : '1.1-1' }} -->
        <!-- </ngx-gauge-value> -->
      </ngx-gauge>
      <span>ความเงียบในห้องโดยสาร</span>
    </li>
    } @if(data.perf_f){
    <li>
      <ngx-gauge
        [type]="gaugeType"
        [value]="$any(data.perf_f)"
        [min]="0"
        [max]="10"
        [thick]="this.isMobileView ? 10 : 15"
        [size]="gaugeSize()"
        foregroundColor="#0753A8"
      >
        <!-- <ngx-gauge-value> -->
        <!-- {{ data.preciseCornering | number : '1.1-1' }} -->
        <!-- </ngx-gauge-value> -->
      </ngx-gauge>
      <span>ความต้านทานการหมุน</span>
    </li>
    } @if(data.perf_g){
    <li>
      <ngx-gauge
        [type]="gaugeType"
        [value]="$any(data.perf_g)"
        [min]="0"
        [max]="10"
        [thick]="this.isMobileView ? 10 : 15"
        [size]="gaugeSize()"
        foregroundColor="#0753A8"
      >
        <!-- <ngx-gauge-value> -->
        <!-- {{ data.comfortable | number : '1.1-1' }} -->
        <!-- </ngx-gauge-value> -->
      </ngx-gauge>
      <span>แรงกรุยบนถนนขรุขระ</span>
    </li>
    } @if(data.perf_h){
    <li>
      <ngx-gauge
        [type]="gaugeType"
        [value]="$any(data.perf_h)"
        [min]="0"
        [max]="10"
        [thick]="this.isMobileView ? 10 : 15"
        [size]="gaugeSize()"
        foregroundColor="#0753A8"
      >
        <!-- <ngx-gauge-value> -->
        <!-- {{ data.comfortable | number : '1.1-1' }} -->
        <!-- </ngx-gauge-value> -->
      </ngx-gauge>
      <span>การหยุดรถ</span>
    </li>
    } @if(data.perf_i){
    <li>
      <ngx-gauge
        [type]="gaugeType"
        [value]="$any(data.perf_i)"
        [min]="0"
        [max]="10"
        [thick]="this.isMobileView ? 10 : 15"
        [size]="gaugeSize()"
        foregroundColor="#0753A8"
      >
        <!-- <ngx-gauge-value> -->
        <!-- {{ data.comfortable | number : '1.1-1' }} -->
        <!-- </ngx-gauge-value> -->
      </ngx-gauge>
      <span>ลายดอกยาง(ดุดัน)</span>
    </li>
    }
  </ul>
</section>
} }
